<template>
  <div class="support-tab shared-index">
    <el-row class="table-title" type="flex" align="center">
      <div class="table-title__left">
        <el-tabs v-model="activeTab" type="card" @tab-click="handleChangeTab">
          <el-tab-pane name="support">
            <div slot="label">
              Hỗ trợ
              <span>({{ total }})</span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div style="display: flex; align-items: center;">
        <export-excel-button
          class="mr-2"
          size="small"
          :disabled="callingAPI"
          :total="total"
          :columns="excelColumns"
          :type="'register_form'"
          :titles="[{ name: 'Yêu cầu hỗ trợ', value: 'support' }]"
          :active-tab="'support'"
        />
        <el-button
          type="primary"
          icon="el-icon-refresh-right"
          size="small"
          @click="handleChangeTab"
        >Làm mới</el-button>
      </div>
    </el-row>
    <list-support
      :loading="callingAPI"
      :data="allUsers"
      @reload="handleReloadAfterDelete"
    />
    <el-row type="flex" justify="end" class="my-4">
      <el-pagination
        :current-page="page"
        :page-size="limit"
        :total="total"
        background
        layout="total, prev, pager, next"
        @current-change="handleChangePage"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ListSupport from './components/List.vue'
import ExportExcelButton from '@/components/buttons/ExportExcel.vue'
import { getUserRegisterForms } from '@/services/register-form'

export default {
  name: 'Support',
  components: {
    ListSupport,
    ExportExcelButton
  },
  data() {
    return {
      visibleUpdate: false,
      callingAPI: false,
      allUsers: [],
      selectedDepartment: {},
      activeTab: 'support',
      total: 0,
      limit: 10,
      page: 1,
      searchText: ''
    }
  },
  computed: {
    ...mapGetters(['language']),
    params() {
      const p = {
        page: this.page,
        per_page: this.limit,
        locale: this.language
      }
      return p
    },
    excelColumns() {
      return [
        { key: 'name', label: 'Tên người dùng', width: 200 },
        { key: 'email', label: 'Email', width: 200 },
        { key: 'phone', label: 'Số điện thoại', width: 150 },
        { key: 'position', label: 'Chức vụ', width: 150 },
        { key: 'workplace', label: 'Đơn vị công tác', width: 200 },
        { key: 'requirements', label: 'Nội dung yêu cầu', width: 300 },
        { key: 'registered_at', label: 'Ngày đăng ký', width: 150 }
      ]
    }
  },
  watch: {
    language: 'loadData'
  },
  beforeMount() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.callingAPI = true
      this.visibleUpdate = false
      getUserRegisterForms(this.params).then((response) => {
        this.allUsers = response.result
        this.total = response.total
        this.callingAPI = false
      }).catch(() => {
        this.callingAPI = false
      })
    },
    handleChangePage(page) {
      this.page = page
      this.loadData()
    },
    handleChangeTab() {
      this.page = 1
      this.loadData()
    },
    handleReloadAfterDelete() {
      if (this.allUsers.length === 1 && this.page > 1) {
        this.page = this.page - 1
      }
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.support-tab {
  .table-title {
    &__left {
      max-width: calc(100% - 200px);
      .el-tabs {
        max-width: 100%;
      }
    }
  }
}
</style>
